import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-area',
  templateUrl: './logo-area.component.html',
  styleUrls: ['./logo-area.component.scss']
})
export class LogoAreaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
